import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams, Link } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle } from "../../common_components/Layout";
import Modal from "../../common_components/Modal";
import { EditableFieldsContainer, EditableField, NonEditableLink } from "../../common_components/EditableFields";
import DateFormatting from "../../common_components/DateFormatting";
import LoadingIcon from "../../common_components/LoadingIcon";
import EditIcon from '../../../../../../../assets/images/researcher_app/overview/pencil_edit_icon.png';
import { PrimaryButton } from "../../common_components/Buttons";
import MissionAttendeesForm from "../../create_mission_components/components/MissionAttendeesForm";




// Api Calls
import MissionsAPI from "../../../api/api_calls/MissionAPI";


function MissionDetailsCard(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()


    const [readableCreatedDate, readableCreatedTime] = DateFormatting.parseISOStringToReadableDateAndTime(props.mission.created_at, props.mission.timezone);
    const readableReviewString = props.mission.requires_researcher_review ? "Yes" : "No";
    const deviceRequirementString = props.mission.device_requirement ? props.mission.device_requirement.charAt(0).toUpperCase() + props.mission.device_requirement.slice(1) : "";
    var otherRequirementsString = props.missionEvent && props.missionEvent.video_required ? "User turns on video, " : "";
    otherRequirementsString += props.mission.require_share_screen ? "User shares screen, " : "";
    otherRequirementsString += props.mission.require_wallet_usage ? "User connects wallet, " : "";
    otherRequirementsString += props.mission.view_user_wallets ? "View user wallets, " : "";
    otherRequirementsString = otherRequirementsString.length > 0 ? otherRequirementsString.slice(0, -2) : "";

    function onSubmit(value, field) {
        console.log("Submitting", value, field)
        const submitValue = {}
        submitValue[field] = value
        submitValue["missionId"] = missionId
        submitValue["handleRedirect"] = navigate

        async function updateMission() {
            const result = await MissionsAPI.update(submitValue);

            if (result.success) {
                alert.show("Project updated", { type: 'success' })
                props.refreshMission()
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }
        updateMission();
    }




    return (
        <Card style={{ flexGrow: 1, width: "100%" }}>
            <GrayCardTitle title="Project Details" />
            {props.loading ? <LoadingIcon /> :
                <EditableFieldsContainer >
                    <EditableField title="Project Name" value={props.mission.name} key={1} name={"name"} editable={true} onSubmit={onSubmit} />
                    <EditableField title="Project Type" value={props.missionType} key={2} editable={false} />
                    <EditableField title="Created" value={readableCreatedDate} key={3} editable={false} />
                    {props.missionType == "Live Feedback" &&
                        <EditableField title="Device Requirement" value={deviceRequirementString} key={4} editable={false} />
                    }
                    {props.missionType == "Live Feedback" && otherRequirementsString.length > 0 &&
                        <EditableField title="Other Requirements" value={otherRequirementsString} key={5} editable={false} />
                    }
                    {props.mission.public &&
                        <NonEditableLink title="Public Access Link" value={props.mission.public_link} key={6} editable={false} fieldType={"link"} />
                    }
                    <EditableField title="Description" value={props.mission.audience_description} key={7} type={"comment"} name={"description"} editable={true} onSubmit={onSubmit} />
                    {props.mission.requires_researcher_review && <EditableField title="Applications Require Review?" value={readableReviewString} key={8} editable={false} />}
                    <EditableField title="Expected Responses" value={props.mission.num_total_spots} key={9} name={"numResponses"} editable={true} onSubmit={onSubmit} />
                    <div className="editable-field-container">
                        <div className="editable-field">
                            <div className="editable-field-title">
                                Pricing
                            </div>
                            <div className="editable-field-value">
                                <Link to={"/missions/" + missionId + "/pricing"} className="white-link">
                                    View Pricing
                                </Link>
                            </div>
                        </div>
                    </div>
                    <EditableModalDiv title="Invited Colleagues" value={props.mission.included_emails} key={10} name={"emails"} editable={true} onSubmit={onSubmit} attendees={props.attendees} addAttendee={props.addAttendee} deleteAttendee={props.deleteAttendee} />
                </EditableFieldsContainer>
            }
        </Card>

    )
}

function EditableModalDiv(props) {
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState(props.value);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const attendeeArray = props.loading ? [] : props.attendees.map((attendee) => {
        return (
            [[attendee.first_name, attendee.last_name].join(" "), attendee.email]
        )
    })

    function onClickEdit() {
        if (props.editable) {
            setEditing(true);
        }
    }

    function onClickSave() {
        setEditing(false);
        props.onSubmit(value, props.name);
    }

    function onChange(event) {
        setValue(event.target.value);
    }

    function toggleModal() {
        setModalIsOpen(prevState => !prevState)
    }



    return (
        <div className="editable-field-container">
            <div className="editable-field">
                <div className="editable-field-title">
                    {props.title}
                </div>
                <div className="editable-div-container">
                    {attendeeArray.map((row, index) => {
                        return (
                            <div key={index} className="editable-row">
                                {row.map((val, val_index) => {
                                    return (
                                        <div key={index + "_" + val_index} className="editable-field-value-text">
                                            {val}
                                        </div>
                                    )
                                })}
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="editable-field-edit-icon" onClick={toggleModal}>
                <img src={EditIcon} />
            </div>
            {modalIsOpen &&
                <UpdateAttendeesModal isOpen={modalIsOpen} toggleModal={toggleModal} attendees={props.attendees} addAttendee={props.addAttendee} deleteAttendee={props.deleteAttendee} />
            }
        </div>

    )
}


function UpdateAttendeesModal(props) {
    const alert = useAlert();
    const { missionId } = useParams()


    function saveAndToggleModal() {
        async function updateAttendees() {
            const result = await MissionsAPI.updateAttendees({ missionId: missionId, attendees: props.attendees });

            if (result.success) {
                alert.show("Attendees updated", { type: 'success' })
                props.toggleModal()
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        updateAttendees();
    }

    return (
        <Modal isOpen={props.isOpen} toggleModal={props.toggleModal}>
            <Card style={{ gap: "32px", maxWidth: "95vw" }}>
                <div className="modal-title">
                    Update Invited Colleagues
                </div>
                <div className="modal-text">
                    Add or remove colleagues that receive invites to research sessions
                </div>
                <MissionAttendeesForm attendees={props.attendees} addAttendee={props.addAttendee} deleteAttendee={props.deleteAttendee} />
                <div className="modal-button-container">
                    <PrimaryButton text="Save" onClick={saveAndToggleModal} />
                </div>
            </Card>
        </Modal>
    )
}

export default MissionDetailsCard;